import React from 'react';
import './styles.css';


const Container = ({ children }) => {
  return (
    <div className="container">{children}</div>
  )
}


export default React.memo(Container);